import { Component, OnInit, Renderer2, SecurityContext, NgZone, ChangeDetectorRef, HostListener } from '@angular/core';
import { Router } from '@angular/router';
import * as _ from 'lodash';
import { Subscription } from 'rxjs';
import { COMMON_CONSTANTS } from 'src/app/common/constants/common-constants';
import { results } from 'src/app/common/models/common.model';
import { AuthenticationService } from 'src/app/common/services/authentication.service';
import { LoaderService } from 'src/app/common/services/loader.service';
import { SharedPopupService } from 'src/app/common/services/shared-popup.service';
import { LandingService } from 'src/app/core/services/landing.service';
import { SharedChatService, ChatPayload } from 'src/app/common/services/shared-chat.service';
import { ConfigurationService } from 'src/app/common/services/configuration.service';
import { CrosstabService } from 'src/app/common/services/crosstab.service';
import { environment } from 'src/app/environments/environment';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { ViewEncapsulation } from '@angular/core';
import { ThemeService } from 'src/app/theme.service';
import { ChatbotService } from 'src/app/common/services/chatbot.service';
import { MsalService } from '@azure/msal-angular';
import { protectedResources } from 'src/app/auth.config';
import { shouldShowBellIcon } from '../../../common/bell-icon-routes.util';

// Fallback theme CSS variables - used when client-specific theme fails to load
const FALLBACK_THEME_CSS = `
:root {
  /* landing page */
  --nav-header-img: url("/assets/images/common/Header.svg");
  --sub-container-bg:rgba(235, 224, 237, 0.90);
  --landing-bg-img:none; /* No background image in fallback - video will show */
  --background-image-url:none;
  --welcome-txt-col:var(--From-Std-Crosstab-Color-1, #8029B6);
  --username-col:var(--From-Std-Crosstab-Color-1, #8029B6);
  --send-button-image:url('/assets/images/explorerPlus/Send_Arrow.svg');
 
  /* Snapshot */
  --snapshot-selection-border:1px solid var(--font-color1, #802ab7);
  --snapshot-active-tab-hover:linear-gradient(90deg, #8600CD 0%, #1110EB 100%) !important;
  --snapshot-active-tab:linear-gradient(90deg, #8600CD 0%, #1110EB 100%);
  --snapshot-tab-hover:linear-gradient(90deg, #8600CD 0%, #1110EB 100%);
  
  --tile-hover-bg-image:url('/assets/images/aesthetics/Tiles_Hover.png');
  --tile-bg-image:url('/assets/images/aesthetics/Tiles_Normal.png');
  
  /*Header*/
  --header-border-gradient: linear-gradient(90deg, #8600CD 0%, #1110EB 100%);
  --snapshot-area-bg-gradient: linear-gradient(180deg, rgba(134, 0, 205, 0.50) 0%, rgba(0, 0, 0, 0.00) 100%);
 
  /* custom reports /custom variables */
  --custom-report:var(var(--font-color1), #802ab7);
  --custom-report-border: 3px solid var(--font-color1);
  --custom-report-header:var(--font-color1);
  --downarrow-img: url('/assets/images/common/Arrow-Down-Icon.svg');
  --uparrow-img: url('/assets/images/common/Arrow-Up-Icon.svg');
  --checkbox-not-selected: url('/assets/images/common/unchecked-icon.svg');
  --checkbox-selected: url('/assets/images/common/checked-icon.svg');
 
  --selectionSelected:var(--font-color1) solid;
  
  --font-color1:#802ab7;
 
  /* insights-button */
  --insights-gradient:linear-gradient(90deg, #8600CD, #1110EB, #8600CD, #1110EB);
 
  /* popups */
  --confirm-btm-yes-no-bg: rgba(134, 0, 205, 0.1);
  --bg-yesno: rgba(134, 0, 205, 0.04);
 
  /* icons-png-svg - Using /assets/ paths since inline CSS resolves from document root */
  --load-btn-img:url(/assets/images/common/Load.svg);
  --load-btn-img-active:url(/assets/ImagesSnapshot/Public/load-active.svg);
 
  --info-img-active:url(/assets/ImagesSnapshot/Public/info-active.svg);
  --info-img-inactive:url(/assets/ImagesSnapshot/Public/info-inactive.svg);
  --info-img:url(/assets/images/common/info.svg);
 
  --delete-img-active:url(/assets/ImagesSnapshot/Public/trash-active.svg);
  --delete-img-inactive:url(/assets/ImagesSnapshot/Public/trash-inactive.svg);
  --delete-img:url(/assets/images/common/Delete.svg);
 
  --share-img-active:url(/assets/ImagesSnapshot/Public/share-active.svg);
  --share-img-inactive:url(/assets/ImagesSnapshot/Public/share-inactive.svg);
  --share-img:url(/assets/images/common/Share.svg);
 
  --search-icon:url(/assets/images/common/SearchIcon.svg);
  --download-btn-img:url('/assets/images/common/download-color-icon.svg');
  --refresh-btn-img:url(/assets/images/common/refresh-icon.svg);
 
  --checked-img:url(/assets/images/common/checked-icon.svg);
  --unchecked-img:url(/assets/images/common/unchecked-icon.svg);
 
  --edit-img:url('/assets/images/common/edit-Icon.svg');
  --edit-img-active:url(/assets/ImagesSnapshot/Public/Icon_edit-Active.svg);
  --duplicate-img:url('/assets/images/common/Duplicate.svg');
  --duplicate-img-active:url(/assets/ImagesSnapshot/Public/Duplicate-Active.svg);
  
  /* arrows */
  --right-arrow-purple:url('/assets/ImagesSnapshot/Public/Right_Arrow_Purple.svg');
  --up-arrow-purple:url('/assets/images/common/UpArrow.svg');
  
  --repeat-img:url("../../../../assets/images/common/repeat.svg");
  --repeat-img-active:url("../../../../assets/images/common/repeat.svg");
  --loader-gif:url("../../../../assets/images/common/loader/Exp+_Loader_White.gif");
  --plus-arcdian : url('/assets/images/common/ExpandIcon.svg');
  --minus-arcdian: url('/assets/images/common/MinimizeIcon.svg');
  --back-btn-img: url('/assets/images/common/Back-color.svg');

  
  /* Module hover/select images */
  --module-hover:url('/assets/images/aesthetics/moduleHoverSelect_New.svg');
  
  --linear-gradient-no-opacity: linear-gradient(90deg, #8600CD 0%, #1110EB 100%);
  --global-black: #000000;
}
`;

@Component({
  selector: 'app-new-landing-page',
  templateUrl: './new-landing-page.component.html',
  styleUrls: ['./new-landing-page.component.css'],
  // encapsulation: ViewEncapsulation.None
})

export class NewLandingPageComponent implements OnInit {
  isLoading : boolean = false
  showVideoBackground: boolean = !environment.dedicatedCss;
  showClientVideo: boolean = false;
  clientVideoUrl: string = '';
  // Cache for client video blob URLs to avoid re-fetching
  private static videoCache: Map<string, string> = new Map();

  modules: any;
  settingsList: any;
  DataUploadName: string = COMMON_CONSTANTS.DataUploadModuleId;
  showNotification: boolean = false;
  notifications: any[] = [];
  //moduleNames
  CrossTabName: string = COMMON_CONSTANTS.CrossTabModuleName;
  SnapShotName: string = COMMON_CONSTANTS.SnapShotModuleName;
  BrandAnalysisName: string = COMMON_CONSTANTS.BrandAnalysisModuleName;
  ReportGeneratorName: string = COMMON_CONSTANTS.ReportGeneratorModuleName;
  ArkName: string = COMMON_CONSTANTS.ARKName;
  MidYearReportName: string = COMMON_CONSTANTS.MidYearReportName;
  studyNames: any;
  CrosstabAccess: boolean = false;
  BrandAnalysisAccess: boolean = false;
  ReportGeneratorAccess: boolean = false;
  MidYearReportAccess: boolean = false;
  triggerNew: boolean = false;
  SnapshotAccess: boolean = false;
  AlertAccess: boolean = false;
  alertModuleAccess:boolean = false;
  ARKtabAccess: boolean = false;
  DataUploadAccess: boolean = false;
  dataUploadAcess: boolean = false;
  isDataUploadShown: boolean = false;
  isSuperAdmin: boolean = false;
  hasAccess: boolean = false;
  modulesRemoved: boolean = true;
  isLoaded: boolean = false;
  isUserManagementShown: boolean = false;
  isAddClientStudyShown: boolean = false;
  isConfigurationShown: boolean = false;
  isClientDropdown: boolean = false;
  isModuleSelected: boolean = false;
  isModuleDirty: boolean = false;
  isSettingToggle: boolean = false;
  hasSingleClient: boolean = false;
  showBellOnRoute: boolean = false;
  clientLogo: string = '';
  configData: any;
  ClientName: any = '';
  ClientDetails: any;
  uniqueClientNames: any;
  uniqueClientNamescount: any = 0;
  StudyName: any = '';
  Studysearchtxt: any;
  uniqueClientStudies: any;
  uniqueClientStudiescount: any = 0;
  isStudyDropdown: boolean = false;
  hasSingleStudy: boolean = false;
  Clientsearchtxt: any;
  ClientStudysearchtxt: any;
  userName: string = '';
  moduleName: string = '';
  inputValue: string = '';
  savedModules: any[] = [];
  leftPanelData: any;
  loadData: any;
  dataUploadData: any;
  showClearAll: boolean = false;
  // Controls visibility of the Report Issue popup for landing page minimal mode
  landingPageReportErrorPopupVisible: boolean = false;
  currentUserAccessLevel: string | null = '';

  // Notification state
  showNotificationPanel: boolean = false;
  hasNewNotifications: boolean = false;
  notificationCount: number = 0;

  // Speech dictation logic
  isSpeechSupported: boolean = false;
  isDictating: boolean = false;
  speechRecognition: any;
  baseInputValue: string = '';

  @HostListener('window:keydown', ['$event'])
  handleKeyboardEvent(event: KeyboardEvent) {
    if (event.ctrlKey && event.shiftKey && event.key.toLowerCase() === 'd') {
      event.preventDefault();
      if (this.isSpeechSupported) {
        this.toggleDictation();
      }
    }
  }

  get isArkModuleActive(): boolean {
    return this.modules.find((module: any) => module.moduleName === this.ArkName)?.is_active || false;
  }
  getSanitizedHtml(html: string): SafeHtml {
  return this.sanitizer.sanitize(SecurityContext.HTML, html) || '';
}
stripHtml(text: string): string {
  return text.replace(/<[^>]*>/g, '');
}
onNotificationClick(notification: any, event: MouseEvent): void {
    const target = event.target as HTMLElement;
    // don't toggle when clicking interactive elements (checkbox, link, button, label, etc.)
    if (target.closest('input, a, button, label, select, textarea')) {
      return;
    }
    notification.checked = !notification.checked;
  }

  /**
   * Handle notification count changes from the panel
   */
  onNotificationCountChange(count: number): void {
    this.notificationCount = count;
    this.hasNewNotifications = count > 0;
  }

  /**
   * Toggle notification panel open/close
   */
  toggleNotificationPanel(): void {
    this.showNotificationPanel = !this.showNotificationPanel;
  }

  // --- Speech Recognition (Dictation) Methods ---
  initSpeechRecognition(): void {
    const SpeechRecognition = (window as any).SpeechRecognition || (window as any).webkitSpeechRecognition;
    if (SpeechRecognition) {
      this.isSpeechSupported = true;
      this.speechRecognition = new SpeechRecognition();
      this.speechRecognition.continuous = true;
      this.speechRecognition.interimResults = true;
      this.speechRecognition.lang = 'en-US';

      this.speechRecognition.onstart = () => {
        this.isDictating = true;
      };

      this.speechRecognition.onresult = (event: any) => {
        let sessionTranscript = '';

        for (let i = 0; i < event.results.length; ++i) {
          let phrase = event.results[i][0].transcript;
          if (sessionTranscript && !sessionTranscript.endsWith(' ') && !phrase.startsWith(' ')) {
            sessionTranscript += ' ';
          }
          sessionTranscript += phrase;
        }

        if (sessionTranscript) {
          sessionTranscript = sessionTranscript.replace(/[\.\?]/g, ' ').replace(/\s+/g, ' ');
          let newValue = this.baseInputValue.replace(/\?$/, '').trim();
          newValue = newValue ? newValue + ' ' + sessionTranscript.trim() : sessionTranscript.trim();
          newValue = newValue + '?';
          this.inputValue = newValue;
          
          setTimeout(() => {
            const inputEl = document.querySelector('.hero-footer-input') as HTMLInputElement;
            if (inputEl) inputEl.scrollLeft = inputEl.scrollWidth;
          }, 0);
        }
      };

      this.speechRecognition.onerror = (event: any) => {
        console.error('Speech recognition error', event.error);
        this.isDictating = false;
      };

      this.speechRecognition.onend = () => {
        this.isDictating = false;
      };
    } else {
      this.isSpeechSupported = false;
    }
  }

  toggleDictation(): void {
    if (!this.isSpeechSupported) return;

    if (this.isDictating) {
      this.stopDictation();
    } else {
      this.baseInputValue = this.inputValue || '';
      this.startDictation();
    }
  }

  startDictation(): void {
    if (this.speechRecognition && !this.isDictating) {
      try {
        this.speechRecognition.start();
      } catch (e) {
        console.error('Failed to start dictation:', e);
      }
    }
  }

  stopDictation(): void {
    if (this.speechRecognition && this.isDictating) {
      try {
        this.speechRecognition.stop();
      } catch (e) {
        console.error('Failed to stop dictation:', e);
      }
    }
  }
  // ----------------------------------------------

  sendInputMessage() {
    if (this.isDictating) {
      this.stopDictation();
    }
    
    if (this.inputValue && this.inputValue.trim() !== '') {
      this.Loader.showLoader();
      this.getBearerToken().then(token => {
        this.chatbotService.accessCheck(
          this.ClientName || 'Demo',
          this.StudyName || 'brand-health-tracker',
          token || ''
        ).subscribe({
          next: (res: any) => {
            this.Loader.hideLoader();
            const guidChatId = res?.session_id || sessionStorage.getItem('session_id');
            const modules_access = res?.modules_access;

            if (guidChatId) {
              sessionStorage.setItem('session_id', guidChatId);
            }

            const payload: ChatPayload = {
              inputValue: this.inputValue,
              clientCode: this.ClientName || 'default_client',
              study: this.StudyName || 'default_study',
              dataArray: this.loadData || [{
                EntryPoint1: null,
                EntryPoint2: null,
                EntryPoint3: null,
                clientName: this.ClientName || 'default_client',
                mandatory_variable_mapping: [],
                dimension: [],
                studyName: this.StudyName || 'default_study',
                isMandatoryLoadClicked: false,
                snapshotType: ''
              }],
              landingData: this.leftPanelData || {},
              guidChatId: guidChatId || undefined,
              modulesAccess: modules_access
            };

            // Emit payload to SharedChatService
            this.sharedChatService.requestSendMessage(payload);

            // Navigate to chatbotexpand with state
            sessionStorage.setItem('fromLanding', 'true');
            this.router.navigate(['/chatbotexpand'], {
              state: {
                fromLandingPage: true,
                client_code: this.ClientName || 'default_client',
                study: this.StudyName || 'default_study',
                inputValue: this.inputValue,
                modules_access: modules_access,
                dataArray: this.loadData || [{
                  EntryPoint1: null,
                  EntryPoint2: null,
                  EntryPoint3: null,
                  clientName: this.ClientName || 'default_client',
                  mandatory_variable_mapping: [],
                  dimension: [],
                  studyName: this.StudyName || 'default_study',
                  isMandatoryLoadClicked: false,
                  snapshotType: ''
                }],
                landingData: this.leftPanelData || {},
                guidChatId: guidChatId || undefined
              }
            });

            this.inputValue = '';
          },
          error: (err) => {
            console.error('[SEND-MESSAGE] Access check failed before navigation:', err);
            this.Loader.hideLoader();
            // Fallback navigation even on error
            this.router.navigate(['/chatbotexpand'], {
              state: { fromLandingPage: true, inputValue: this.inputValue, client_code: this.ClientName, study: this.StudyName }
            });
          }
        });
      }).catch(err => {
        console.error('[SEND-MESSAGE] Token acquisition failed:', err);
        this.Loader.hideLoader();
        this.router.navigate(['/chatbotexpand'], {
          state: { fromLandingPage: true, inputValue: this.inputValue, client_code: this.ClientName, study: this.StudyName }
        });
      });
    } else {
      console.warn('Input value is empty or invalid');
    }
  }

  //settinglist
  SettingList: any = [
    { iconClass: "managementIcon", displayLabel: "User Management", value: "userManagement", hasAccess: false },
    { iconClass: "common/aesthetics/reportManagementIcon", displayLabel: "Report Management", value: "reportManagement", hasAccess: false },
    { iconClass: "bellIcon", displayLabel: "Alert Management", value: "alertManagement", hasAccess: this.AlertAccess },
    { iconClass: "clientDetailsIcon", displayLabel: "Add/Change Client Details", value: "clientDetails", hasAccess: false },
    { iconClass: "dataUploadIcon", displayLabel: "Data Upload Module", value: "dataUpload", hasAccess: this.dataUploadAcess },//need to set isActive as true, once we receive help doc
    { iconClass: "snapshotViewsIcon", displayLabel: "Snapshot Views", value: "snapshotViews", hasAccess: true },
    // Report an Issue always available when a client & study are chosen
    { iconClass: "common/aesthetics/reportIssueIcon", displayLabel: "Report an Issue", value: "reportIssue", hasAccess: true },
    { iconClass: "logoutIcon", displayLabel: "Log Out", value: "Logout", hasAccess: true },
  ]

  private env = environment.env;
  private subscriptions: Subscription = new Subscription();
  isCrossTab: boolean = false;
  isSnapshot: boolean = false;
  isBrandAnalysis: boolean = false;
  isReportGenerator: boolean = false;
  isARKA: boolean = false;
  isMidYearReport: boolean = false;
  crossTabData: any;
  alertData: any;
  snapshotData: any;
  snapshotConfigData: any;
  brandAnalysisData: any;
  reportGeneratorData: any;
  arkaData: any;
  midYearReportData: any;



  constructor(private renderer: Renderer2, private _authenticateService: AuthenticationService,
    private router: Router,
    private Loader: LoaderService,
    private _configService: SharedPopupService,
    private landingService: LandingService,
    private configService: ConfigurationService,
    private crosstabService: CrosstabService,
    private sharedChatService: SharedChatService,
    private sharedPopup:SharedPopupService,private sanitizer: DomSanitizer,
    private themeService: ThemeService,
    private chatbotService: ChatbotService,
    private msalService: MsalService,
    private ngZone: NgZone,
    private cdr: ChangeDetectorRef
  ) { }

  ngOnInit(): void {
    this.initSpeechRecognition();
    this.showBellOnRoute = shouldShowBellIcon(this.router.url);
    sessionStorage.clear();
    this.initializeAuthentication();
  }



  initializeAuthentication() {
    const roleData = localStorage.getItem('role');
    if (roleData) {
      this.getAccess();
      this.setupAfterAuthentication();
    } else {
      this.Loader.showLoader();
      this.subscriptions.add(
        this._authenticateService.AuthenticateUsers().subscribe((result: results) => {
          if (result.HasValidData) {
            this.getAccess();
            this.setupAfterAuthentication();
          } else {
            this._authenticateService.logout();
          }
          this.Loader.hideLoader();
        })
      );
    }
  }

  setDefaultStudyIfSingle() {
    if (this.studyNames && this.studyNames.length === 1) {
      this.StudyName = this.studyNames[0];
      this.landingService.setSelectedStduy(this.StudyName);
      this.modulesRemoved = false;
      this.isStudyDropdown = false;

      // if(this.AlertAccess) {

        const studyAlertActive = this.alertData?.[0]?.UniqueStudies
          ?.find((a:any) => a.StudyName === this.StudyName)
          ?.ModuleActive ?? false 
        this.AlertAccess = this.alertModuleAccess && studyAlertActive;
        this.landingService.setAlertAccess(this.AlertAccess, this.ClientName, this.StudyName);

        this.SettingList = this.SettingList.map((x: any) => {
          if (x.value === 'alertManagement') {
            return { ...x, hasAccess: this.AlertAccess };
          }
          if (x.value === 'reportManagement') {
            return { ...x, hasAccess: this.isSuperAdmin };
          }
          return x;
        });
      // }

      if(this.DataUploadAccess) {

        this.dataUploadAcess = this.dataUploadData?.[0]?.UniqueStudies
          ?.find((a:any) => a.StudyName === this.StudyName)
          ?.ModuleActive ?? false

        this.SettingList = this. SettingList.map((x:any) => {
          if(x.value == 'dataUpload') {
            return { ...x, hasAccess: this.DataUploadAccess && this.dataUploadAcess };
          }
          if (x.value === 'reportManagement') {
            return { ...x, hasAccess: this.isSuperAdmin };
          }
          return x;
        })
      }

      this.modules.map((data: any) => { 
        data.is_active = false;
        if (data.moduleName === this.CrossTabName && this.crossTabData.some((x: any) =>
          Array.isArray(x.UniqueStudies) && x.UniqueStudies.some((u: any) => u.StudyName === this.StudyName && u.ModuleActive)
        )) {
          data.is_active = true;
        } else if (data.moduleName === this.SnapShotName && this.snapshotConfigData.some((x: any) =>
        Array.isArray(x.UniqueStudies) && x.UniqueStudies.some((u: any) => u.StudyName === this.StudyName && u.ModuleActive)
        )) {
          data.is_active = true;
          this.getSnapShotClient();
        } else if (data.moduleName === this.BrandAnalysisName && this.brandAnalysisData.some((x: any) =>
          Array.isArray(x.UniqueStudies) && x.UniqueStudies.some((u: any) => u.StudyName === this.StudyName && u.ModuleActive)
        )) {
          data.is_active = true;
        }else if (data.moduleName === this.ArkName && this.arkaData.some((x: any) =>
          Array.isArray(x.UniqueStudies) && x.UniqueStudies.some((u: any) => u.StudyName === this.StudyName && u.ModuleActive)
        )) {
          data.is_active = true;
        }
        else if (data.moduleName === this.ReportGeneratorName && this.reportGeneratorData.some((x: any) =>
          Array.isArray(x.UniqueStudies) && x.UniqueStudies.some((u: any) => u.StudyName === this.StudyName && u.ModuleActive)
        )) {
          data.is_active = true;
        } else if (data.moduleName === this.MidYearReportName && this.midYearReportData.some((x: any) =>
          Array.isArray(x.UniqueStudies) && x.UniqueStudies.some((u: any) => u.StudyName === this.StudyName && u.ModuleActive)
        )) {
          data.is_active = true;
        }
      }
      );
      this.checkNotifications();
      this.checkArkAccess();
    }
  }

  setupAfterAuthentication() {
    // if user has no access return
    if (this.currentUserAccessLevel == this._authenticateService.level4) {
      return;
    }

    if (this.isSuperAdmin) {
      this.SettingList = this.SettingList.map((option: any) => {
        if (option.value === "alertManagement") {
          return { ...option, hasAccess: this.AlertAccess };
        }
        if (option.value === "reportManagement") {
          return { ...option, hasAccess: true }; // Only super admin can see report management
        }
        return { ...option, hasAccess: true };
      });
    } else {
      // For non-super admin users, hide report management
      this.SettingList = this.SettingList.map((option: any) => {
        if (option.value === "reportManagement") {
          return { ...option, hasAccess: false };
        }
        return option;
      });
    }
    this.userName = this.isSuperAdmin ? "Super Admin!" : this.userName;
    this.modules = [
      { moduleName: this.SnapShotName, access: this.SnapshotAccess, is_active: false, is_selected: false },
      { moduleName: this.CrossTabName, access: this.CrosstabAccess, is_active: false, is_selected: false },
      { moduleName: this.BrandAnalysisName, access: this.BrandAnalysisAccess, is_active: false, is_selected: false },
      { moduleName: this.ArkName, access: this.ARKtabAccess, is_active: false, is_selected: false },
      { moduleName: this.ReportGeneratorName, access: this.ReportGeneratorAccess, is_active: false, is_selected: false },
      { moduleName: this.MidYearReportName, access: this.MidYearReportAccess, is_active: false, is_selected: false },
    ];

    this.getAllClientdetails();
  }

  getAllClientdetails() {
    this.Loader.showLoader();
    this.subscriptions.add(this.landingService.getlandingAllClientList().subscribe((result) => {
    const ClientDetails = JSON.parse(result.Data);

      const data = JSON.parse(result.Data);
      const logoFile = data[0].logoFile;
      if (logoFile) {
        this.clientLogo = logoFile.url ?? '';
      }
      this.ClientDetails = ClientDetails.filter((client: any) =>
        client.moduledetails.some((module: any) => module.is_active)
      );

      const uniqueClientNames = [...new Set(this.ClientDetails.map((client: any) => client.client_name))].sort();
      this.uniqueClientNames = uniqueClientNames.map(name => ({ clientName: name }));
      this.uniqueClientNamescount = this.uniqueClientNames.length;


      if (this.uniqueClientNames.length == 1) {
        this.ClientName = this.uniqueClientNames[0].clientName;
        this.StudyName = 'Study Name';
        this.hasSingleClient = true;
        this.applyRestoredClientState(this.ClientName);
        this.loadThemeAndInitialize(this.ClientName);
      } else {
        this.Loader.showLoader()
        // Try to restore previous selection
        this.showVideoBackground = false;
        const savedClient = this.landingService.getSelectedClient();
        if (savedClient && savedClient !== 'Choose Client' && this.uniqueClientNames.some((item: { clientName: string }) => item.clientName === savedClient)) {
          this.ClientName = savedClient;
          this.StudyName = this.landingService.getSelectedStudy() || 'Study Name';
          this.applyRestoredClientState(savedClient);
          this.loadThemeAndInitialize(savedClient);
        } else {
          this.Loader.showLoader()
          this.ClientName = "Choose Client";
          this.StudyName = 'Study Name';
          // Clear client selection and load fallback theme
          localStorage.setItem('selectedClient', 'Choose Client');
          this.landingService.setSelectedClient('Choose Client');
          this.showVideoBackground = true;
          this.applyFallbackTheme();
        }
      }

      this.Loader.hideLoader();
    }));
  }

  private applyRestoredClientState(clientName: string) {
    this.isModuleSelected = false;
    this.isModuleDirty = false;
    this.modules.forEach((data: any) => {
      data.is_selected = false;
    });
    this.modulesRemoved = false;
    this.isClientDropdown = false;
    this.ClientName = clientName;
    const savedStudyName = this.landingService.getSelectedStudy();
    this.StudyName = savedStudyName || 'Study Name';
    this.landingService.setSelectedClient(clientName);
    localStorage.setItem('selectedClient', clientName);
    if (!this.DataUploadAccess) {
      let clientdetails = this.ClientDetails.find((x: any) => {
        if (x.client_name == clientName) {
          return x;
        }
      });

      this.DataUploadAccess = clientdetails.moduledetails.find(
      (a: any) => a.module_name.toLowerCase() === 'data upload')?.is_active ?? false;

    }

    // if(!this.AlertAccess){
    //   let clientdetails = this.ClientDetails.find((x: any) => {
    //     if (x.client_name == clientName) {
    //       return x;
    //     }
    //   });
              
    //   this.AlertAccess = clientdetails.moduledetails.find(
    //   (a: any) => a.module_name.toLowerCase() === 'alert')?.is_active ?? false;
    // }
  }
  private afterLandingClientListLoaded() {
    if (this.studyNames && this.studyNames.length === 1) {
      this.StudyName = this.studyNames[0];
      this.landingService.setSelectedStduy(this.StudyName);
    }
    this.StudyNameclick(this.StudyName);
    this.loadClientVideo();
  }

 ClientNameSelectclick(clientName: any) {
  this.isModuleSelected = false;
  this.isModuleDirty = false;
  this.AlertAccess = false;
  this.hasNewNotifications = false;
  this.showNotificationPanel = false;
  this.modules.forEach((data: any) => {
    data.is_selected = false;
  });
  this.modulesRemoved = true;
  this.isClientDropdown = false;
  
  // Clear previous client's video cache if switching clients
  if (this.ClientName && this.ClientName !== clientName && this.ClientName !== 'Choose Client') {
    this.clearVideoCache(this.ClientName);
  }
  
  this.ClientName = clientName;
  this.StudyName = 'Study Name';
  localStorage.setItem('selectedClient', clientName);
  
  // Load theme first, then initialize data
  this.loadThemeAndInitialize(clientName);
  
  this.landingService.setSelectedClient(clientName);
  let clientdetails = this.ClientDetails.find((x: any) => {
    if (x.client_name == clientName) {
      return x;
    }
  });
            
    //this.AlertAccess = true;
    this.DataUploadAccess = true;
    
    // Reconstruct and set theme URL dynamically based on selected client
    // this.updateThemeCssUrl(clientName);
    
    // this.AlertAccess = clientdetails.moduledetails.find(
    // (a: any) => a.module_name.toLowerCase() === 'alert')?.is_active ?? false;

    // this.DataUploadAccess = clientdetails.moduledetails.find(
    // (a: any) => a.module_name.toLowerCase() === 'data upload')?.is_active ?? false;
  }

  /**
   * Reconstruct and dynamically update the theme CSS URL based on selected client
   * This reuses the same logic from configuration component
   * Runs asynchronously without blocking UI
   * @param clientName The selected client name
   */
  /**
 * Load theme and initialize data only after theme is fully loaded
 * This prevents layout issues caused by race conditions
 */
private loadThemeAndInitialize(clientName: string): void {
  this.Loader.showLoader();

  if (environment.dedicatedCss) {
    this.showVideoBackground = false;
    this.getAllLandingClientListAndStudies(clientName, () => this.afterLandingClientListLoaded());
    return;
  }

  this.configService.getLogo(clientName).subscribe(
    (result: any) => {
      if (result.fileName != undefined && result.url != undefined) {
        this.showVideoBackground = false;
        const logoUrl = result.url;
        
        // Build Azure theme URL from logo URL
        const queryIndex = logoUrl.indexOf('?');
        const urlWithoutQuery = queryIndex > 0 ? logoUrl.substring(0, queryIndex) : logoUrl;
        const sasToken = queryIndex > 0 ? logoUrl.substring(queryIndex) : '';
        
        const lastSlashIndex = urlWithoutQuery.lastIndexOf('/');
        if (lastSlashIndex > 0) {
          const secondLastSlashIndex = urlWithoutQuery.lastIndexOf('/', lastSlashIndex - 1);
          if (secondLastSlashIndex > 0) {
            const baseUrl = urlWithoutQuery.substring(0, secondLastSlashIndex);
            const themeUrl = `${baseUrl}/css/theme.css${sasToken}`;
            
            // Wait for theme to load before proceeding with data initialization
            this.setDynamicThemeCssWithCallback(themeUrl, () => {
              this.getAllLandingClientListAndStudies(clientName, () => this.afterLandingClientListLoaded());
            });
          } else {
            // console.warn('Failed to parse logo URL structure, applying fallback theme');
            this.showVideoBackground = true;
            this.applyFallbackTheme();
            this.getAllLandingClientListAndStudies(clientName, () => this.afterLandingClientListLoaded());
          }
        } else {
          // console.warn('Failed to parse logo URL structure, applying fallback theme');
          this.showVideoBackground = true;
          this.applyFallbackTheme();
          this.getAllLandingClientListAndStudies(clientName, () => this.afterLandingClientListLoaded());
        }
      } else {
        this.showVideoBackground = true;
        // console.warn('Logo URL not found for client:', clientName, '- applying fallback theme');
        this.applyFallbackTheme();
        this.getAllLandingClientListAndStudies(clientName, () => this.afterLandingClientListLoaded());
      }
    },
    (error: any) => {
      // console.error('Error fetching logo for client:', clientName, error);
      this.applyFallbackTheme();
      this.showVideoBackground = true;
      this.getAllLandingClientListAndStudies(clientName, () => this.afterLandingClientListLoaded());
    }
  );
}

  
 /**
 * Dynamically update the theme CSS link with callback for completion
 * @param themeUrl The new theme CSS URL
 * @param callback Function to call after theme is loaded
 */
private setDynamicThemeCssWithCallback(themeUrl: string, callback: () => void): void {
  if (!themeUrl) {
    this.applyFallbackTheme();
    callback();
    return;
  }

  // Add cache buster
  const urlWithCacheBuster = themeUrl.includes('?') 
    ? themeUrl + `&v=${Date.now()}` 
    : themeUrl + `?v=${Date.now()}`;

  let themeLink = document.querySelector('link[data-theme="custom-theme"]') as HTMLLinkElement;
  
  if (!themeLink) {
    themeLink = document.createElement('link');
    themeLink.rel = 'stylesheet';
    themeLink.setAttribute('data-theme', 'custom-theme');
    document.head.appendChild(themeLink);
  }

  // Error handler
  themeLink.onerror = () => {
    // console.error('Failed to load theme CSS:', themeUrl);
    this.applyFallbackTheme();
    callback(); // Proceed even if theme fails
  };

  // Success handler
  themeLink.onload = () => {
    
    const fallback = document.querySelector('style[data-theme="fallback-theme"]');
    if (fallback) {
      fallback.remove();
    }
    
    // Cache the theme URL so index.html can load it instantly on next refresh
    localStorage.setItem('client-theme-url', themeUrl);
    
    // Load client video from theme CSS variable after theme is applied
    setTimeout(() => {
      this.loadClientVideo();
      callback();
    }, 100);
    this.Loader.hideLoader();

  };

  themeLink.href = urlWithCacheBuster;
}
/**
 * Get the module hover/select image based on current theme
 * Reads from CSS variable set by theme.css
 */
getModuleHoverImage(): string {
  // If no client selected, use fallback image
  if (!this.ClientName || this.ClientName === 'Choose Client') {
    return '/assets/images/aesthetics/moduleHoverSelect_New.svg';
  }
  
  // Read CSS variable from theme (set by theme.css)
  const computedStyle = getComputedStyle(document.documentElement);
  const moduleHoverVar = computedStyle.getPropertyValue('--module-hover').trim();
  
  // Extract URL from CSS variable (removes "url('...')" wrapper)
  if (moduleHoverVar) {
    const match = moduleHoverVar.match(/url\(['"]?(.+?)['"]?\)/);
    if (match && match[1]) {
      return match[1];
    }
  }
  
  // Fallback if CSS variable not found
  return '/assets/images/aesthetics/moduleHoverSelect_New.svg';
}
  /**
   * Apply fallback theme CSS when client-specific theme fails to load
   */
  applyFallbackTheme(): void {
  // Clear cached theme URL so index.html doesn't inject a stale client theme on next load
  localStorage.removeItem('client-theme-url');

  let fallback = document.querySelector('style[data-theme="fallback-theme"]') as HTMLStyleElement;
  
  if (!fallback) {
    fallback = document.createElement('style');
    fallback.setAttribute('data-theme', 'fallback-theme');
    fallback.textContent = FALLBACK_THEME_CSS;
    document.head.appendChild(fallback);
  }
  
  // ✅ Critical: Show fallback video when fallback theme is active
  if (!environment.dedicatedCss) {
    this.showVideoBackground = true;
    this.showClientVideo = false;
    this.clientVideoUrl = '';
    this.clearVideoCache();
  }
}

  /**
   * Load client video from backend API (proxies Azure File Storage)
   * This avoids CORS and Range header issues
   */
  loadClientVideo(): void {
    if (!environment.dedicatedCss && (!this.ClientName || this.ClientName === 'Choose Client')) {
      this.showClientVideo = false;
      return;
    }

    const cacheKey = environment.dedicatedCss ? '__dedicated_video__' : this.ClientName;

    // In-memory cache
    const cachedUrl = NewLandingPageComponent.videoCache.get(cacheKey);
    if (cachedUrl) {
      this.clientVideoUrl = cachedUrl;
      this.showClientVideo = true;
      this.showVideoBackground = false;
      setTimeout(() => this.playVideo(), 100);
      return;
    }

    // IndexedDB cache with 24h TTL
    this.loadFromAssetCache(cacheKey, (blob) => {
      if (blob) {
        const url = URL.createObjectURL(blob);
        NewLandingPageComponent.videoCache.set(cacheKey, url);
        this.clientVideoUrl = url;
        this.showClientVideo = true;
        this.showVideoBackground = false;
        this.cdr.detectChanges();
        setTimeout(() => this.playVideo(), 100);
      } else {
        // Fetch from backend and cache
        const videoObs = environment.dedicatedCss
          ? this.configService.getDedicatedLandingVideo()
          : this.configService.getLandingVideo(this.ClientName);
        videoObs.subscribe({
          next: (blob: Blob) => {
            const blobUrl = URL.createObjectURL(blob);
            NewLandingPageComponent.videoCache.set(cacheKey, blobUrl);
            this.clientVideoUrl = blobUrl;
            this.showClientVideo = true;
            this.showVideoBackground = false;
            this.cdr.detectChanges();
            setTimeout(() => this.playVideo(), 100);
            this.saveToAssetCache(cacheKey, blob);
          },
          error: () => this.showClientVideo = false
        });
      }
    });
  }

  // --- IndexedDB asset cache with 24h TTL ---

  private static readonly CACHE_TTL = 24 * 60 * 60 * 1000; // 24 hours

  private openAssetDb(): Promise<IDBDatabase> {
    return new Promise((resolve, reject) => {
      const req = indexedDB.open('DedicatedAssetCache', 1);
      req.onupgradeneeded = (e: any) => {
        const db = e.target.result;
        if (!db.objectStoreNames.contains('assets')) db.createObjectStore('assets');
      };
      req.onsuccess = (e: any) => resolve(e.target.result);
      req.onerror = () => reject();
    });
  }

  private loadFromAssetCache(key: string, cb: (blob: Blob | null) => void): void {
    this.openAssetDb().then(db => {
      const req = db.transaction('assets', 'readonly').objectStore('assets').get(key);
      req.onsuccess = () => {
        this.ngZone.run(() => {
          const entry = req.result;
          if (entry && (Date.now() - entry.ts) < NewLandingPageComponent.CACHE_TTL) {
            cb(entry.blob);
          } else {
            cb(null);
          }
        });
      };
      req.onerror = () => cb(null);
    }).catch(() => cb(null));
  }

  private saveToAssetCache(key: string, blob: Blob): void {
    this.openAssetDb().then(db => {
      db.transaction('assets', 'readwrite').objectStore('assets').put({ blob, ts: Date.now() }, key);
    }).catch(() => {});
  }

  private playVideo(): void {
    const video = document.getElementById('clientBgVideo') as HTMLVideoElement;
    if (video) {
      video.muted = true;
      video.play().catch(() => {
        setTimeout(() => video.play().catch(() => {}), 500);
      });
    }
  }

  /**
   * Clear video cache for a specific client or all clients
   */
  private clearVideoCache(clientName?: string): void {
    if (clientName) {
      const cachedUrl = NewLandingPageComponent.videoCache.get(clientName);
      if (cachedUrl) {
        URL.revokeObjectURL(cachedUrl);
        NewLandingPageComponent.videoCache.delete(clientName);
      }
    } else {
      // Clear all cached videos
      NewLandingPageComponent.videoCache.forEach((url) => URL.revokeObjectURL(url));
      NewLandingPageComponent.videoCache.clear();
    }
  }

  getAccess() {
    let moduleAccessBasedOnRole = localStorage.getItem('role');
    const access = this._authenticateService.GetLandingPageAccess();
    this.currentUserAccessLevel = access;

    // if user has no access return
    if (this.currentUserAccessLevel === this._authenticateService.level4) {
      return;
    }

    if (access !== null) {
      this.GetRoleValidation(access);
    }

    // Process moduleAccessBasedOnRole data when available
    if (moduleAccessBasedOnRole != null) {
      let userData = JSON.parse(atob(moduleAccessBasedOnRole))
      this.userName = userData.first_name + '!';
      localStorage.setItem('useremail', userData.email);
      let arr = _.map(_.uniqBy(userData.access, 'module_name'), (element: any) => element.module_name);
      if (environment.showUploadModule) {
        if (userData.super_admin == true) {
          this.isDataUploadShown = true;
        }
        else {
          if (_.includes(arr, this.DataUploadName)) {
            this.isDataUploadShown = true;
          } else {
            this.isDataUploadShown = false;
          }
        }
      } else {
        this.isDataUploadShown = false;
      }

      if (userData.super_admin) {
        this.CrosstabAccess = true;
        this.BrandAnalysisAccess = true;
        this.SnapshotAccess = true;
        this.ReportGeneratorAccess = true;
        this.MidYearReportAccess = true;
        this.isSuperAdmin = true;
        this.alertModuleAccess = true;
      }
      else if (arr != null) {
        this.CrosstabAccess = _.includes(arr, this.CrossTabName);
        this.BrandAnalysisAccess = _.includes(arr, this.BrandAnalysisName);
        this.SnapshotAccess = _.includes(arr, this.SnapShotName);
        this.ReportGeneratorAccess = _.includes(arr, this.ReportGeneratorName);
        this.MidYearReportAccess = _.includes(arr, this.MidYearReportName);
        this.alertModuleAccess = _.includes(arr, 'Alert');
      }

      if (this.isSuperAdmin) {
        this.ARKtabAccess = true;
      }
    }
  }

  moduleKey: number = 0;


  moduleSelected(item: any) {
    this.isModuleDirty = true;
    this.moduleName = item.moduleName;

    // Report Generator: direct redirect without study selection
    if (this.moduleName === this.ReportGeneratorName) {
      const data = {
        client_code: this.ClientName,
        study: this.StudyName || '',
        studyList: this.uniqueClientStudies?.map((x: any) => x.studyName) || []
      };
      this.router.navigateByUrl('US-Brand-Perception-Report', { state: data });
      return;
    }

    // Mid Year Report: direct redirect without study selection
    if (this.moduleName === this.MidYearReportName) {
      const data = {
        client_code: this.ClientName,
        study: this.StudyName || '',
        studyList: this.uniqueClientStudies?.map((x: any) => x.studyName) || []
      };
      this.router.navigateByUrl('Mid-Year-Report', { state: data });
      return;
    }

    this.isModuleSelected = false; // force hide first

    // delay re-show to force destroy/recreate
    setTimeout(() => {
      this.isModuleSelected = true;
      this.moduleKey++; // unique key, triggers re-render
    });
    // Unselect all modules
    this.modules.forEach((m: any) => (m.is_selected = false));

    // Select the clicked module
    item.is_selected = true;
    // this.studyNames = this.uniqueClientStudies.map((x:any) => x.studyName);
    // Load the appropriate data based on module name
    switch (this.moduleName) {
      case this.SnapShotName:
        this.configData = this.snapshotData;
        // this.studyNames = this.snapshotData?.[0]?.UniqueSnapshots
        //   .filter((s: any) => this.StudyName === "" ? true : s.StudyNames.includes(this.StudyName)).map((s: any) => s.SnapshotName) || [];
        this.studyNames = this.snapshotData?.[0]?.UniqueSnapshots
          .filter((s: any) => this.StudyName === "" ? true : (s.StudyNames[0].study_name == (this.StudyName))  && s.SnapshotName != null 
            && s.SnapshotName.trim() !== "" ).map((s: any) => s.SnapshotName) || [];
        break;
      case this.CrossTabName:
        this.configData = this.crossTabData;
        this.studyNames = this.crossTabData.map((x: any) => x.UniqueStudies) || [];
        break;
      case this.BrandAnalysisName:
        this.configData = this.brandAnalysisData;
        this.studyNames = this.brandAnalysisData.map((x: any) => x.UniqueStudies) || [];
        break;
      case this.ReportGeneratorName:
        this.configData = this.reportGeneratorData;
        this.studyNames = this.reportGeneratorData.map((x: any) => x.UniqueStudies) || [];
        break;
      case this.ArkName:
        this.configData = this.arkaData;
        this.studyNames = this.arkaData.map((x: any) => x.UniqueStudies) || [];
        break;
      case this.MidYearReportName:
        this.configData = this.midYearReportData;
        this.studyNames = this.midYearReportData.map((x: any) => x.UniqueStudies) || [];
        break;
    }
  }

  // Animate selection between items
  animateSelection(startIndex: number, endIndex: number) {
    const step = startIndex < endIndex ? 1 : -1;

    for (let i = startIndex; i !== endIndex + step; i += step) {
      setTimeout(() => {

        this.modules.forEach((m: any) => (m.is_selected = false));
        if (i > -1) {
          this.modules[i].is_selected = true;
          if (this.moduleName == this.modules[i].moduleName) {
            switch (this.moduleName) {
              case this.SnapShotName:
                this.configData = this.snapshotData;
                this.studyNames = this.snapshotData.map((x: any) => x.UniqueStudies) || [];
                break;
              case this.CrossTabName:
                this.configData = this.crossTabData;
                this.studyNames = this.crossTabData.map((x: any) => x.UniqueStudies) || [];
                break;
              case this.BrandAnalysisName:
                this.configData = this.brandAnalysisData;
                this.studyNames = this.brandAnalysisData.map((x: any) => x.UniqueStudies) || [];
                break;
              case this.ReportGeneratorName:
                this.configData = this.reportGeneratorData;
                this.studyNames = this.reportGeneratorData.map((x: any) => x.UniqueStudies) || [];
                break;
              case this.ArkName:
                this.configData = this.arkaData;
                this.studyNames = this.arkaData.map((x: any) => x.UniqueStudies) || [];
                break;
              case this.MidYearReportName:
                this.configData = this.midYearReportData;
                this.studyNames = this.midYearReportData.map((x: any) => x.UniqueStudies) || [];
                break;
            }
          }
        }
      }, Math.abs(i - startIndex) * 60); // 100ms delay per step
    }
  }

  getClientData(): void {
    this.Loader.showLoader();
    this.subscriptions.add(this.landingService.getlandingClientList(this.moduleName).subscribe((result) => {
      if (result.HasValidData) {
        this.configData = JSON.parse(result.Data);
        this._configService.setPopUpData(this.configData, this.moduleName);
        this.studyNames = this.configData.find((x: any) => {
          if (x.ClientName == this.ClientName)
            return x;
        });
        this.isModuleSelected = false;
        setTimeout(() => {
          this.isModuleSelected = true;
        }, 50); // Introduce a small delay (50ms)
      }
      this.Loader.hideLoader();
    }));
  }

  getSnapShotClient(): void {
    this.studyNames = null;
    this.Loader.showLoader();
    this.subscriptions.add(this.landingService.getSnapshotlandingClientList().subscribe((result) => {
      if (result.HasValidData) {
        let configData = JSON.parse(result.Data);

        configData.sort((a: any, b: any) => {
          if (a.ClientName.toLowerCase() < b.ClientName.toLowerCase()) {
            return -1; // a comes before b  
          }
          if (a.ClientName.toLowerCase() > b.ClientName.toLowerCase()) {
            return 1; // a comes after b  
          }
          return 0; // a and b are equal  
        });

        configData.forEach((item: any) => {
          if (item.UniqueSnapshots) {
            item.UniqueSnapshots.sort((a: any, b: any) => {
              const nameA = a.SnapshotName.toLowerCase();
              const nameB = b.SnapshotName.toLowerCase();
              return nameA < nameB ? -1 : nameA > nameB ? 1 : 0;
            });
          }
          if (item.UniqueStudies) {
            item.UniqueStudies.sort((a: any, b: any) => {
              const nameA = a.toLowerCase();
              const nameB = b.toLowerCase();
              return nameA < nameB ? -1 : nameA > nameB ? 1 : 0;
            });
          }
        });
        this.studyNames = configData.find((x: any) => {
          if (x.ClientName == this.ClientName)
            return x;
        });
        this._configService.setPopUpData(configData, "");
        // this.isModuleSelected = false;

        // setTimeout(() => {
        //   this.isModuleSelected = true;
        // }, 50); // Introduce a small delay (50ms)
      }
      this.Loader.hideLoader();
    }));
  }
  
checkNotifications() {
  if (!this.AlertAccess) {
    return;
  }

  const study = this.landingService.getSelectedStudy() ?? '';
  const client = this.landingService.getSelectedClient() ?? '';
  const userEmail = localStorage.getItem('useremail') ?? '';
  
  if (!study || !client || !userEmail) return;
  
  this.sharedPopup.getTriggeredAlertList(userEmail, client, study).subscribe((value: any) => {
    const parsedData = JSON.parse(value.Data);
    this.notificationCount = parsedData.TriggeredAlerts.totalCount || 0;
    if (this.notificationCount > 0) {
      this.hasNewNotifications = true;
    } else {
      this.hasNewNotifications = false;
    }
  });
}

  GetRoleValidation(access: string): void {
    this.Loader.showLoader();

    this.subscriptions.add(
      this._authenticateService.roleValidation().subscribe((result: results) => {
        if (result.HasValidData) {
          const storedRole = localStorage['role'];
          const userRole = result.Data;

          if (storedRole !== undefined && storedRole !== userRole) {
            this._authenticateService.logout();
          } else {
            this.isLoaded = true;
            this.hasAccess = access !== this._authenticateService.level4;

            
            // Set visibility flags based on access level
            this.isAddClientStudyShown = access === this._authenticateService.level1;
            this.isUserManagementShown =
              access === this._authenticateService.level1 ||
              access === this._authenticateService.level2;
            if (this._authenticateService.level1 || this._authenticateService.level2) {
              this.SettingList.filter((x: any) => {
                if (x.value == 'userManagement') {
                  x.hasAccess = true;
                }
                // if (x.value === 'alertManagement') {
                //   x.hasAccess = this.AlertAccess;
                // }
              })
            }
            this.isConfigurationShown = access === this._authenticateService.level1;
          }
        }
        this.Loader.hideLoader();
      })
    );
  }

  ngAfterViewInit() {

    const video = document.getElementById('bgVideo') as HTMLVideoElement;

    if (video) {
      // Try to play the video immediately
      video.play().catch(() => {
        this.addUserInteraction(video);
      });

      // Ensure looping
      video.addEventListener('ended', () => {
        video.currentTime = 0;
        video.play();
      });
    }
  }

  // Add event listener to play video on first user interaction
  private addUserInteraction(video: HTMLVideoElement) {
    const playOnUserInteraction = () => {
      video.play();
      document.removeEventListener('click', playOnUserInteraction);
      document.removeEventListener('touchstart', playOnUserInteraction);
    };

    document.addEventListener('click', playOnUserInteraction);
    document.addEventListener('touchstart', playOnUserInteraction);
  }

  openClientDropdown() {
    this.isClientDropdown = !this.isClientDropdown;
  }

  onOptionClick(item: any) {
    let data: { client_code: string; study: string; studyList: any } = {
      client_code: this.ClientName,
      study: this.StudyName,
      studyList: []
    };
    switch (item) {
      case this.SettingList[0].value:
        this.router.navigateByUrl('user-management');
        break;
      case this.SettingList[1].value:
        this.router.navigateByUrl('report-management');
        break;
      case this.SettingList[2].value:
        this.router.navigateByUrl('alert-management', { state: data });
        break;
      case this.SettingList[3].value:
        this.router.navigateByUrl('configuration');
        break;
      case this.SettingList[4].value:
        this.router.navigateByUrl('dataupload');
        break;
      case this.SettingList[5].value:
        // Open Figma link for Snapshot Views
        window.open('https://www.figma.com/proto/7fV2UmWwIX7XJPGLDPoyk3/Explorer--Snapshot-Visuals?page-id=0%3A1&node-id=95-4612&viewport=3126%2C1977%2C0.23&t=HYEZhoeaEEp2zyIq-8&scaling=contain&content-scaling=fixed&starting-point-node-id=95%3A4612&hide-ui=1', '_blank');
        break;
      case 'reportIssue':
        // Show minimal report issue popup
        this.landingPageReportErrorPopupVisible = true;
        this.isSettingToggle = false; // Close settings dropdown
        break;
      case this.SettingList[7].value:
        this._authenticateService.logout();
        break;
    }
  }

  ngOnDestroy() {
    this.subscriptions.unsubscribe();
    // Don't revoke blob URL here - it's cached for reuse
    // Cache cleanup happens in clearVideoCache() when client changes
  }

  // Add this function to open the study dropdown
  openStudyDropdown() {
    this.isStudyDropdown = !this.isStudyDropdown;
  }

  // Add this function to handle study selection
  onStudySelect(study: any) {
    // Logic to handle the selection of study
    this.isStudyDropdown = false;
    // Handle what happens when a study is selected, e.g., store the selected study
  }

  getAllLandingClientListAndStudies(clientName: string, callback?: () => void) {
    this.Loader.showLoader();
    this.subscriptions.add(this.landingService.getAllLandingClientList().subscribe((result) => {
      let clientData: any;

      if (typeof result.data === 'string') {
        clientData = JSON.parse(result.data);
      } else {
        clientData = result.data;
      }
   
      // Prepare the final output array
      const studiesData = clientData.map((client: any) => {
        let isCrossTab = false;
        let isSnapshot = false;
        let isBrandAnalysis = false;
        let isReportGenerator = false;
        let isARKA = false;
        let isAlert = false;
        let isDataUpload = false;
        let isMidYearReport = false;

        // Initialize filtered data for each module
        let snapshotData = [];
        let snapshotConfigData = [];
        let crosstabData = [];
        let brandAnalysisData = [];
        let reportGeneratorData = [];
        let arkData = [];
        let alertData = [];
        let dataUploadData = [];
        let midYearReportData: any[] = [];

        // Initialize an array to collect all study names
        let allStudyNames: string[] = [];
      
        // Process Snapshot config Data
        if (client.snapshotConfigData && typeof client.snapshotConfigData === 'string') {
          const snapshotConfigJson = JSON.parse(client.snapshotConfigData);
          const parsedSnapshotConfigData = snapshotConfigJson.Data ? JSON.parse(snapshotConfigJson.Data) : [];
          snapshotConfigData = parsedSnapshotConfigData.filter((study: any) => study.ClientName === clientName);

          if (snapshotConfigData.length > 0) {
            isSnapshot = true;
          }
          snapshotConfigData.forEach((client: any) => {
            if (Array.isArray(client.UniqueStudies)) {
              //  allStudyNames = allStudyNames.concat(study.UniqueStudies);
              client.UniqueStudies.forEach((study: any) => {
                allStudyNames.push(study.StudyName);
              })
            }
          });
        }

             // Process Snapshot Data
        if (client.snapshot && typeof client.snapshot === 'string') {
          const snapshotJson = JSON.parse(client.snapshot);
          const parsedSnapshotData = snapshotJson.Data ? JSON.parse(snapshotJson.Data) : [];
          snapshotData = parsedSnapshotData.filter((study: any) => study.ClientName === clientName);
          // if (snapshotConfigData.length > 0) {
          //   isSnapshot = true;
          // }
        }

        // Process Crosstab Data
        if (client.crosstab && typeof client.crosstab === 'string') {
          const crosstabJson = JSON.parse(client.crosstab);
          const parsedCrosstabData = crosstabJson.Data ? JSON.parse(crosstabJson.Data) : [];
          crosstabData = parsedCrosstabData.filter((study: any) => study.ClientName === clientName);
          if (crosstabData.length > 0) isCrossTab = true;
          crosstabData.forEach((client: any) => {
            if (Array.isArray(client.UniqueStudies)) {
              //  allStudyNames = allStudyNames.concat(study.UniqueStudies);
              client.UniqueStudies.forEach((study: any) => {
                allStudyNames.push(study.StudyName);
              })
            }
          });
        }

        // Process Brand Analysis Data
        if (client.brandanalysis && typeof client.brandanalysis === 'string') {
          const brandAnalysisJson = JSON.parse(client.brandanalysis);
          const parsedBrandAnalysisData = brandAnalysisJson.Data ? JSON.parse(brandAnalysisJson.Data) : [];
          brandAnalysisData = parsedBrandAnalysisData.filter((study: any) => study.ClientName === clientName);
          if (brandAnalysisData.length > 0) isBrandAnalysis = true;
          brandAnalysisData.forEach((client: any) => {
            if (Array.isArray(client.UniqueStudies)) {
              //  allStudyNames = allStudyNames.concat(study.UniqueStudies);
              client.UniqueStudies.forEach((study: any) => {
                allStudyNames.push(study.StudyName);
              })
            }
          });
        }

        if (client.reportGenerator && typeof client.reportGenerator === 'string') {
          const reportGeneratorJson = JSON.parse(client.reportGenerator);
          const parsedReportGeneratorData = reportGeneratorJson.Data ? JSON.parse(reportGeneratorJson.Data) : [];
          reportGeneratorData = parsedReportGeneratorData.filter((study: any) => study.ClientName === clientName);
          if (reportGeneratorData.length > 0) isReportGenerator = true;
          reportGeneratorData.forEach((client: any) => {
            if (Array.isArray(client.UniqueStudies)) {
              client.UniqueStudies.forEach((study: any) => {
                allStudyNames.push(study.StudyName);
              })
            }
          });
        }

        // Process ARK Data
        if (client.ark && typeof client.ark === 'string') {
          const arkJson = JSON.parse(client.ark);
          const parsedArkData = arkJson.Data ? JSON.parse(arkJson.Data) : [];
          arkData = parsedArkData.filter((study: any) => study.ClientName === clientName);
          if (arkData.length > 0) isARKA = true;
          arkData.forEach((client: any) => {
            if (Array.isArray(client.UniqueStudies)) {
              //  allStudyNames = allStudyNames.concat(study.UniqueStudies);
              client.UniqueStudies.forEach((study: any) => {
                allStudyNames.push(study.StudyName);
              })
            }
          });
        }
        
      
         // Process ARK Data
        if (client.alert && typeof client.alert === 'string') {
          const alertJson = JSON.parse(client.alert);
          const parsedAlertData = alertJson.Data ? JSON.parse(alertJson.Data) : [];
          alertData = parsedAlertData.filter((study: any) => study.ClientName === clientName);
          if (alertData.length > 0) isAlert = true;
          alertData.forEach((client: any) => {
            if (Array.isArray(client.UniqueStudies)) {
              //  allStudyNames = allStudyNames.concat(study.UniqueStudies);
              client.UniqueStudies.forEach((study: any) => {
                allStudyNames.push(study.StudyName);
              })
            }
          });
        }

        if (client.dataupload && typeof client.dataupload === 'string') {
        const dataUploadJson = JSON.parse(client.dataupload);
        const parsedDataUploadData = dataUploadJson.Data ? JSON.parse(dataUploadJson.Data) : [];
        dataUploadData = parsedDataUploadData.filter((study: any) => study.ClientName === clientName);
        if (dataUploadData.length > 0) isDataUpload = true;
        dataUploadData.forEach((client: any) => {
          if (Array.isArray(client.UniqueStudies)) {
            client.UniqueStudies.forEach((study: any) => {
              allStudyNames.push(study.StudyName);
            })
          }
        });
      }

        // Process Mid Year Report Data
        if (client.midYearReport && typeof client.midYearReport === 'string') {
          const midYearReportJson = JSON.parse(client.midYearReport);
          const parsedMidYearReportData = midYearReportJson.Data ? JSON.parse(midYearReportJson.Data) : [];
          midYearReportData = parsedMidYearReportData.filter((study: any) => study.ClientName === clientName);
          if (midYearReportData.length > 0) isMidYearReport = true;
          midYearReportData.forEach((c: any) => {
            if (Array.isArray(c.UniqueStudies)) {
              c.UniqueStudies.forEach((study: any) => {
                allStudyNames.push(study.StudyName);
              });
            }
          });
        }
        
        const uniqueStudyNames = [...new Set(allStudyNames)];
        this.uniqueClientStudiescount = uniqueStudyNames.length;
        return {
          clientName: clientName,
          snapshotData: snapshotData,
          snapshotConfigData: snapshotConfigData,
          crosstabData: crosstabData,
          brandAnalysisData: brandAnalysisData,
          reportGeneratorData: reportGeneratorData,
          arkData: arkData,
          isCrosstab: isCrossTab,
          isSnapshot: isSnapshot,
          isBrandAnalysis: isBrandAnalysis,
          isReportGenerator: isReportGenerator,
          isARKA: isARKA,
          studyNames: uniqueStudyNames,
          isAlert: isAlert,
          alertData: alertData,
          isDataUpload: isDataUpload,
          dataUploadData: dataUploadData,
          isMidYearReport: isMidYearReport,
          midYearReportData: midYearReportData,
        };
      });
      this.uniqueClientStudies = studiesData.map((client: any) => {
        return client.studyNames.map((study: any) => ({ studyName: study }));
      }).reduce((acc: any, curr: any) => acc.concat(curr), []);
      this.isCrossTab = studiesData.some((client: any) => client.isCrosstab);
      this.isSnapshot = studiesData.some((client: any) => client.isSnapshot);
      this.isBrandAnalysis = studiesData.some((client: any) => client.isBrandAnalysis);
      this.isReportGenerator = studiesData.some((client: any) => client.isReportGenerator);
      this.isARKA = studiesData.some((client: any) => client.isARKA);
      this.isMidYearReport = studiesData.some((client: any) => client.isMidYearReport);
      this.crossTabData = studiesData.find((x: any) => x.isCrosstab)?.crosstabData || [];
      this.alertData = studiesData.find((x: any) => x.isAlert)?.alertData || [];
      this.snapshotConfigData = studiesData.find((x: any) => x.isSnapshot)?.snapshotConfigData || [];
      this.snapshotData = studiesData.find((x: any) => x.isSnapshot)?.snapshotData || [];
      this.brandAnalysisData = studiesData.find((x: any) => x.isBrandAnalysis)?.brandAnalysisData || [];
      this.reportGeneratorData = studiesData.find((x: any) => x.isReportGenerator)?.reportGeneratorData || [];
      this.arkaData = studiesData.find((x: any) => x.isARKA)?.arkData || [];
      this.dataUploadData = studiesData.find((x: any) => x.isDataUpload)?.dataUploadData || [];
      this.midYearReportData = studiesData.find((x: any) => x.isMidYearReport)?.midYearReportData || [];
      this.studyNames = studiesData.find((x: any) => x.clientName === clientName)?.studyNames || [];
      this.setDefaultStudyIfSingle();
      this.Loader.hideLoader();
      if (callback) callback();
    }));
  }

  StudyNameclick(studyName: any) {
    this.StudyName = studyName;
    this.isStudyDropdown = false;
    this.isModuleSelected = false;
    this.isModuleDirty = false;
    this.modulesRemoved = false;
    this.landingService.setSelectedStduy(studyName);
    // if(this.AlertAccess){
      localStorage.setItem('selectedStudy', studyName);

      const studyAlertActive = this.alertData?.[0]?.UniqueStudies
            ?.find((a: any) => a.StudyName === this.StudyName)
            ?.ModuleActive ?? false
      this.AlertAccess = this.alertModuleAccess && studyAlertActive;
      this.landingService.setAlertAccess(this.AlertAccess, this.ClientName, studyName);

      this.SettingList = this.SettingList.map((x: any) => {
        if (x.value === 'alertManagement') {
          return { ...x, hasAccess: this.AlertAccess };
        }
        if (x.value === 'reportManagement') {
          return { ...x, hasAccess: this.isSuperAdmin };
        }
        return x;
      });
    // }

    if(this.DataUploadAccess) {
      this.dataUploadAcess = this.dataUploadData?.[0]?.UniqueStudies
            ?.find((a: any) => a.StudyName === this.StudyName)
            ?.ModuleActive ?? false

      this.SettingList = this.SettingList.map((x:any) => {
        if(x.value === 'dataUpload') {
          return { ...x, hasAccess: this.DataUploadAccess && this.dataUploadAcess };
        }
        if (x.value === 'reportManagement') {
          return { ...x, hasAccess: this.isSuperAdmin };
        }
        return x;
      });
    }
    this.modules.forEach((mod: any) => {
      mod.is_active = false;
      mod.is_selected = false;
      const match = (arr: any[]) => arr?.some((c: any) =>
        Array.isArray(c?.UniqueStudies) && c.UniqueStudies.some((s: any) => s.StudyName === studyName && s.ModuleActive)
      );
      switch (mod.moduleName) {
        case this.CrossTabName:
          mod.is_active = match(this.crossTabData);
          break;
        case this.SnapShotName:
          mod.is_active = match(this.snapshotConfigData);
          if (mod.is_active) { this.getSnapShotClient(); }
          break;
        case this.BrandAnalysisName:
          mod.is_active = match(this.brandAnalysisData);
          break;
        case this.ReportGeneratorName:
          mod.is_active = match(this.reportGeneratorData);
          break;
        case this.ArkName:
          mod.is_active = match(this.arkaData);
          break;
        case this.MidYearReportName:
          mod.is_active = match(this.midYearReportData);
          break;
      }
    });
    this.checkNotifications();
    this.checkArkAccess();
  }

  /**
   * Load fallback theme when no client is selected
   */
  private loadFallbackTheme(): void {
    // Pass empty string to ThemeService to load fallback theme
    this.themeService.loadTheme('');
  }

  getBearerToken(): Promise<string> {
    return new Promise((resolve) => {
      let account = this.msalService.instance.getActiveAccount();
      if (!account) {
        const accounts = this.msalService.instance.getAllAccounts();
        if (accounts && accounts.length > 0) {
          account = accounts[0];
          this.msalService.instance.setActiveAccount(account);
        }
      }
      if (!account) {
        resolve('');
        return;
      }
      this.msalService.instance.acquireTokenSilent({
        scopes: protectedResources.Api.scopes.read,
        account: account
      }).then(tokenResponse => {
        resolve(`Bearer ${tokenResponse.accessToken}`);
      }).catch(error => {
        console.error('Token acquisition failed in landing page', error);
        resolve('');
      });
    });
  }

  checkArkAccess() {
    if (this.ClientName && this.ClientName !== 'Choose Client' && this.StudyName && this.StudyName !== 'Study Name') {
      this.getBearerToken().then(token => {
        let studyHasArk = false;
        if (this.arkaData && this.arkaData.length > 0) {
          this.arkaData.forEach((c: any) => {
            if (Array.isArray(c.UniqueStudies)) {
              c.UniqueStudies.forEach((study: any) => {
                if (study.StudyName === this.StudyName && study.ModuleActive === true) {
                  studyHasArk = true;
                }
              });
            }
          });
        } 

        if (studyHasArk) {
          this.chatbotService.accessCheckAskMeAnything(this.ClientName, this.StudyName, token).subscribe({
            next: (res: any) => {
              this.ARKtabAccess = res?.has_access === true;
              const arkModule = this.modules.find((m: any) => m.moduleName === this.ArkName);
              if (arkModule) {
                arkModule.access = this.ARKtabAccess;
                arkModule.is_active = this.ARKtabAccess;
              }
            },
            error: (err) => {
              console.error('[ARK-DEBUG] Failed to check AMA access:', err);
              this.ARKtabAccess = false;
              const arkModule = this.modules.find((m: any) => m.moduleName === this.ArkName);
              if (arkModule) {
                arkModule.access = false;
                arkModule.is_active = false;
              }
            }
          });
        } else {
          this.ARKtabAccess = false;
          const arkModule = this.modules.find((m: any) => m.moduleName === this.ArkName);
          if (arkModule) {
            arkModule.access = false;
            arkModule.is_active = false;
          }
        }
      });
    }
  }

}

